






















import MapElemInfoComment from './MapElemInfoComment/index.vue';
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  reactive,
  watch,
} from '@vue/composition-api';
import { MapElemInfo } from '@/models';
import { GeoItemMeta } from '@/models/geoItem';
import { Comment } from '@/models/apis/comment/commentResponse';

interface MapElemInfoNewState {
  selectedDataType: string;
  elemConv: MapElemInfo<Comment> | null;
}

export default defineComponent({
  name: 'map-elem-info-new',
  props: {
    elem: {
      type: Object as PropType<MapElemInfo<Comment>>,
      required: true,
    },
    visibleLayers: {
      type: Array as PropType<GeoItemMeta[]>,
      default: () => { return []; },
    },
    forceShowCancelButton: {
      type: Boolean,
      default: false,
    },
    createFailed: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const state = reactive<MapElemInfoNewState>({
      selectedDataType: '',
      elemConv: null,
    });

    const initDisplay = () => {
      const creatableLayers = props.visibleLayers.filter(e => e.isCreatable);
      state.selectedDataType = creatableLayers.length > 0 ? creatableLayers[0].name : '';
      if (props.elem) {
        state.elemConv = {
          dataName: state.selectedDataType,
          data: props.elem.data,
        };
      }
    };

    onMounted(initDisplay);

    watch(() => props.elem, initDisplay);
    watch(() => props.visibleLayers, () => {
      const arr = props.visibleLayers.map(e => e.name);
      if (!arr.includes(state.selectedDataType)) {
        initDisplay();
      }
    });

    const currentElemInfoComponent = computed(() => {
      if (!state.elemConv) { return ''; }
      return 'map-elem-info-' + state.elemConv.dataName;
    });
    const selectableDataTypes = computed(() => {
      return props.visibleLayers.filter(e => e.isCreatable).map(e => {
        return { name: e.name, dispName: e.dispName };
      });
    });

    const onChildComponentUpdate = (obj: MapElemInfo<Comment>) => {
      // イベント種別を変換して投げ直す
      emit('create', obj);
    };

    return {
      state,
      // computeds
      currentElemInfoComponent,
      selectableDataTypes,
      // methods
      onChildComponentUpdate,
    };
  },
  components: {
    MapElemInfoComment,
  },
});
